import { DEFAULT_EXPENSES_KEYS, DEFAULT_EXPENSES_TITLES, UTILITIES_EXPENSES_MODE } from 'shared/constants/expenses';

export const EXPENSE_COMPS_DEFAULT_FILTERS = [
  {
    name: 'grossBuildingArea',
    title: 'Gross Building Area',
    propertyName: 'grossBuildingArea',
    isNumeric: true,
  },
  {
    name: 'yearBuilt',
    title: 'Year Built',
    propertyName: 'yearBuilt',
  },
  {
    name: 'residentialUnits',
    title: 'No. of Residential Units',
    propertyName: 'residentialUnitCount',
    isNumeric: true,
  },
  {
    name: 'totalOperatingExpenses',
    title: 'Total Operating Expense/SF',
    propertyName: 'totalOperatingExpenses',
    isTotal: true,
  },
  {
    name: 'totalOperatingExpensesPerUnit',
    title: 'Total Operating Expense/Unit',
    propertyName: 'totalOperatingExpensesPerUnit',
    isTotal: true,
  },
  {
    name: 'expenseYear',
    title: 'Expense Year',
    propertyName: 'expenseYear',
  },
];

export const UTILITIES_EXPENSES_MODE_OPTIONS = [
  { value: UTILITIES_EXPENSES_MODE.BROKEN_OUT, label: 'Broken Out' },
  { value: UTILITIES_EXPENSES_MODE.COMBINED_ELECTRICITY_AND_FUEL, label: 'Combined Electricity & Fuel' },
  { value: UTILITIES_EXPENSES_MODE.COMBINED_ALL, label: 'Combined Electricity, Fuel, Water & Sewer' },
];

export const PRICE_PER_SQUARE_FEET_POSTFIX = ' ($/SF)';
export const PRICE_PER_UNIT_POSTFIX = ' ($/Unit)';

export const DEFAULT_EXPENSES_PROPERTIES = [
  {
    searchResultName: DEFAULT_EXPENSES_KEYS.insurance,
    name: 'insurance',
    title: DEFAULT_EXPENSES_TITLES.insurance,
  },
  {
    searchResultName: DEFAULT_EXPENSES_KEYS.electricity,
    name: 'electricity',
    title: DEFAULT_EXPENSES_TITLES.electricity,
  },
  {
    searchResultName: DEFAULT_EXPENSES_KEYS.fuel,
    name: 'fuel',
    title: DEFAULT_EXPENSES_TITLES.fuel,
  },
  {
    searchResultName: DEFAULT_EXPENSES_KEYS.waterAndSewer,
    name: 'waterAndSewer',
    title: DEFAULT_EXPENSES_TITLES.waterAndSewer,
  },
  {
    searchResultName: DEFAULT_EXPENSES_KEYS.repairsAndMaintenance,
    name: 'repairsAndMaintenance',
    title: DEFAULT_EXPENSES_TITLES.repairsAndMaintenance,
  },
  {
    searchResultName: DEFAULT_EXPENSES_KEYS.payrollAndBenefits,
    name: 'payrollAndBenefits',
    title: DEFAULT_EXPENSES_TITLES.payrollAndBenefits,
  },
  {
    searchResultName: DEFAULT_EXPENSES_KEYS.generalAndAdministrative,
    name: 'generalAndAdministrative',
    title: DEFAULT_EXPENSES_TITLES.generalAndAdministrative,
  },
  {
    searchResultName: DEFAULT_EXPENSES_KEYS.legalAndProfessionalFees,
    name: 'legalAndProfessionalFees',
    title: DEFAULT_EXPENSES_TITLES.legalAndProfessionalFees,
  },
  {
    searchResultName: DEFAULT_EXPENSES_KEYS.miscellaneous,
    name: 'miscellaneous',
    title: DEFAULT_EXPENSES_TITLES.miscellaneous,
  },
  {
    searchResultName: DEFAULT_EXPENSES_KEYS.managementFees,
    name: 'managementFees',
    title: DEFAULT_EXPENSES_TITLES.managementFees,
  },
  {
    searchResultName: DEFAULT_EXPENSES_KEYS.replacementReserves,
    name: 'replacementReserves',
    title: DEFAULT_EXPENSES_TITLES.replacementReserves,
  },
];

export const DIALOG_FILTER_TITLE = 'Expense Comp Search';
export const DIALOG_UNITS_TITLE = 'Expense Comp Results';

export const ERROR_MESSAGE = 'Unable to load expense comps. For more information, please contact support.';
